export interface ContainRect {
  left: number;
  top: number;
  width: number;
  height: number;
}

export function computeContainRect(
  containerWidth: number,
  containerHeight: number,
  mediaWidth: number,
  mediaHeight: number,
): ContainRect {
  const safeContainerWidth = Number(containerWidth);
  const safeContainerHeight = Number(containerHeight);
  const safeMediaWidth = Number(mediaWidth);
  const safeMediaHeight = Number(mediaHeight);

  if (
    !Number.isFinite(safeContainerWidth)
    || !Number.isFinite(safeContainerHeight)
    || !Number.isFinite(safeMediaWidth)
    || !Number.isFinite(safeMediaHeight)
    || safeContainerWidth <= 0
    || safeContainerHeight <= 0
    || safeMediaWidth <= 0
    || safeMediaHeight <= 0
  ) {
    return {
      left: 0,
      top: 0,
      width: Math.max(0, safeContainerWidth || 0),
      height: Math.max(0, safeContainerHeight || 0),
    };
  }

  const containerAspect = safeContainerWidth / safeContainerHeight;
  const mediaAspect = safeMediaWidth / safeMediaHeight;

  if (containerAspect > mediaAspect) {
    const height = safeContainerHeight;
    const width = height * mediaAspect;
    return {
      left: (safeContainerWidth - width) / 2,
      top: 0,
      width,
      height,
    };
  }

  const width = safeContainerWidth;
  const height = width / mediaAspect;
  return {
    left: 0,
    top: (safeContainerHeight - height) / 2,
    width,
    height,
  };
}
